export default __webpack_public_path__ + "static/GrotesqueNo9-Regular-7e1775ab32d3e72a57df8c98da0543a0.woff2";